import * as React from 'react';
import ReactDOM from 'react-dom';
import { useUnmount } from 'react-use';

import { AuthStatus, useAuth } from 'auth';
import Icon from 'components/icon';
import { getUserName } from 'my-account/utils/user';

const NotificationBar: React.VFC = () => {
  const auth = useAuth();
  const [isStopping, setIsStopping] = React.useState(false);

  const isBeingImpersonated = auth.status === AuthStatus.LoggedIn && !!auth.impersonatingUser;

  const element = React.useMemo(() => {
    let notificationBar = document.getElementById('impersonation-notification-bar');
    if (notificationBar) {
      return notificationBar;
    }

    const siteHeader = document.getElementById('site-header');

    if (!siteHeader) {
      return null;
    }

    notificationBar = document.createElement('div');
    notificationBar.id = 'impersonation-notification-bar';

    siteHeader.parentNode?.insertBefore(notificationBar, siteHeader);

    return notificationBar;
  }, []);

  useUnmount(() => {
    if (element) {
      element.remove();
    }
  });

  if (!isBeingImpersonated || !element || !auth.impersonatingUser) {
    return null;
  }

  const currentUser = auth.currentUser;
  const currentUserName = [currentUser.first_name, currentUser.last_name].filter(Boolean).join(' ');

  return ReactDOM.createPortal(
    <section className="c-info-strip c-color--invert">
      <div className="o-container">
        <div className="o-row">
          <div className="o-col-6@sm">
            <div className="c-info-strip__inner">
              <span className="c-info-strip__icon">
                <Icon name="avatar" className="o-svg-icon" />
              </span>
              <p className="c-info-strip__note">
                Viewing as <strong>{currentUserName}</strong>.
              </p>
            </div>
          </div>
          <div className="o-col-6@sm">
            <div className="c-info-strip__inner u-justify-end">
              <p className="c-info-strip__note">
                Switch back to {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  className="c-link-cta"
                  onClick={async (event) => {
                    event.preventDefault();
                    if (isStopping) {
                      return;
                    }

                    setIsStopping(true);
                    try {
                      await auth.stopImpersonating();
                    } catch (error) {
                      console.error('Failed to stop impersonating.', error);
                      setIsStopping(false);
                    }
                  }}
                >
                  <span>{getUserName(auth.impersonatingUser).name}</span>
                  <Icon name="arrow" className="o-svg-icon o-svg-right" />
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>,
    element
  );
};

export const ImpersonationNotificationBar: React.VFC = () => {
  const auth = useAuth();

  const isBeingImpersonated = auth.status === AuthStatus.LoggedIn && !!auth.impersonatingUser;

  if (!isBeingImpersonated) {
    return null;
  }

  return <NotificationBar />;
};
